import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class TopmostMessage extends WebViewMessage {
  public constructor(public topmost?: boolean) {
    super(MessageType.Topmost);
  }
}
